// extracted by mini-css-extract-plugin
export var active = "_c0-c";
export var compactArrow = "_c0-5";
export var container = "_c0-0";
export var dot = "_c0-b";
export var dotContainer = "_c0-a";
export var hoverArrowButton = "_c0-7";
export var hoverArrowContainer = "_c0-6";
export var leftHoverArrowContainer = "_c0-8 _c0-6";
export var rightHoverArrowContainer = "_c0-9 _c0-6";
export var slide = "_c0-4";
export var sliderContainer = "_c0-1";
export var sliderContainerVisibleOverflow = "_c0-2";
export var sliderOverflow = "_c0-3";
export var vignetteBoth = "_c0-f";
export var vignetteLeft = "_c0-e";
export var vignetteRight = "_c0-d";